import { Middleware } from 'redux';
import {
    reconcileUnsavedSnapshot,
    updateUnsavedSnapshot,
} from './unsaved-changes';

const trackedOfferActions = new Set([
    'SET_OFFER_CLIENT',
    'SET_OFFER_RECIPE',
    'GET_RECIPE_FOR_OFFER_SUCCESS',
    'GET_RECIPE_FOR_OFFER_SUCCESS',
    'SET_OFFER_LANGUAGE',
    'UPDATE_FIELD_VALUE',
    'UPDATE_OPTION_NAME',
    'UPDATE_ITEM_QUANTITY',
    'UPDATE_ITEM_MARGIN',
    'OVERRIDE_OFFER_MARGIN',
    'TOGGLE_SERVICE',
    'CHANGE_OFFER_PRODUCT',
    'ADD_PRODUCT_TO_OFFER',
    'ADD_SERVICE_TO_OFFER',
    'TOGGLE_PRODUCT_SERVICE',
    'DELETE_PRODUCT',
    'DELETE_SERVICE',
    'REFRESH_OFFER_PRICES_SUCCESS',
]);

export const getOfferGuardPath = (pathname: string): string | null => {
    const match = pathname.match(/^\/panel\/offers\/(new|edit\/[^/]+)(?:\/|$)/);
    return match ? `/panel/offers/${match[1]}` : null;
};

const getOfferSnapshot = (offer: any) => ({
    client: offer.client,
    recipe: offer.recipe && offer.recipe.id,
    components: offer.components,
    additionalServices: offer.additionalServices,
    additionalProducts: offer.additionalProducts,
    infoValues: offer.infoValues,
    infoVisibility: offer.infoVisibility,
    fieldVisibility: offer.fieldVisibility,
    quantities: offer.quantities,
    lengths: offer.lengths,
    itemVisibility: offer.itemVisibility,
    itemInactive: offer.itemInactive,
    sectionVisibility: offer.sectionVisibility,
    componentVisibility: offer.componentVisibility,
    fieldValues: offer.fieldValues,
    descriptionVisibility: offer.descriptionVisibility,
    descriptionValues: offer.descriptionValues,
    margins: offer.margins,
    fieldNames: offer.fieldNames,
    infoNames: offer.infoNames,
    optionNames: offer.optionNames,
    language: offer.language,
});

const middleware: Middleware = ({ getState }) => (next) => (action: any) => {
    const guardPath = getOfferGuardPath(window.location.pathname);
    if (!guardPath || !action || typeof action.type !== 'string') {
        return next(action);
    }

    const formId = `offer-editor:${guardPath}`;

    if (
        action.type === 'GET_RECIPE_FOR_OFFER_SUCCESS' &&
        !window.location.pathname.startsWith('/panel/offers/new')
    ) {
        return next(action);
    }

    if (action.type === 'REFRESH_DATA') {
        const result = next(action);
        reconcileUnsavedSnapshot(
            formId,
            getOfferSnapshot(getState().offer),
            'Konfiguracja oferty',
            guardPath
        );
        return result;
    }

    if (!trackedOfferActions.has(action.type)) return next(action);
    if (
        action.type === 'SET_OFFER_CLIENT' &&
        action.meta?.unsavedChanges !== true
    ) {
        return next(action);
    }

    const before = getOfferSnapshot(getState().offer);
    const result = next(action);
    const after = getOfferSnapshot(getState().offer);

    updateUnsavedSnapshot(
        formId,
        before,
        after,
        'Konfiguracja oferty',
        guardPath
    );

    return result;
};

export default middleware;